<template>
  <div id="home" class="zweigi">
    <h1 class="text-center is-size-1">Wach</h1>
    <v-divider></v-divider>
    <div v-for="post in sitemap.posts" :key="post.slug">
        <v-card :to="post.slug">
            <v-card-title class="title">
                <h5 class="tit">{{ post.title }}</h5>
            </v-card-title>
            <v-card-text class="text">
                <p class="body-1 blackx">{{ post.summary }}</p>
                <v-chip-group column v-if="post.kategorien && kategorien.kategorien">
                  <div v-for="chip in kategorien.kategorien" :key="chip.title"><v-chip color="#686de0" v-if="typeof post.kategorien.find(x => x == chip.slug) != 'undefined'">{{chip.title}}</v-chip></div>
                  <div v-for="autor in autoren.autoren" :key="autor.vorname"><v-chip color="#0fb9b1" v-if="typeof post.autoren.find(x => x == autor.mail) != 'undefined'">{{autor.vorname + ' ' + autor.nachname}}</v-chip></div>
                </v-chip-group>
            </v-card-text>
        </v-card>
        <v-divider></v-divider>
    </div>
  </div>
</template>

<style scoped>
a {
  text-decoration: none; /* no underline */
}
.title{
    padding-bottom: 0px;
}
.text{
    padding-top: 0px;
}
.tit{
    margin: 0px 0px 0px;
}
.blackx{
  color: black;
}
h1{
  font-family: forgetica;
}
</style>

<script>
  import { db } from '../db'
  const blog = db.collection('blog');
  export default {
    name: 'home',
    data: () => ({
      sitemap: {},
      autoren: {},
      kategorien: {}
    }),
    firestore: {
      sitemap: blog.doc('sitemap'),
      autoren: blog.doc('autoren'),
      kategorien: blog.doc('kategorien')
    },
    mounted(){
      this.$Progress.finish()
    },
    metaInfo: {
      meta: [
          {
            name: 'description',
            content: 'Bewusste Artikel.'
          }
        ]
    }
  }
</script>